export const smoothScrollBehavior = { block: 'center', behavior: 'smooth' };
